import { InverterFormGroupContent } from '@/api/interfaces/content/form/steps/plantPerformance/inverterContent';

export const inverterContent: InverterFormGroupContent = {
    inverterHeadline: {
        text: 'Wechselrichter',
    },
    inverterManufacturerAndModuleType: {
        label: 'Hersteller und Typ',
        manufacturerSelect: {
            placeholder: 'Bitte wählen',
            search: {
                placeholder: 'Filter',
                noResults: 'Keine Ergebnisse',
            },
        },
        manufacturerText: {
            placeholder: 'Muster',
        },
        moduleTypeSelect: {
            placeholder: 'Bitte wählen',
            search: {
                placeholder: 'Filter',
                noResults: 'Keine Ergebnisse',
            },
        },
        moduleTypeText: {
            placeholder: 'Muster Boy 2.5',
        },
    },
    inverterZerezIdAndNorm: {
        label: 'ZEREZ-ID und Norm',
        zerezId: {
            placeholder: 'Bitte wählen',
            search: {
                placeholder: 'Filter',
                noResults: 'Keine Ergebnisse',
            },
        },
        normText: {
            placeholder: 'VDE AR N 4105 VDE AR-N 4110',
            info:
                'Die Prüfung wird auf Basis des angegeben Zertifikats durchgeführt. Es obliegt dem Anlagenbetreiber die Gültigkeit des Zertifikats zum Zeitpunkt der Inbetriebnahme sicherzustellen, oder ein Folgezertifikat anzubringen. In jedem Fall muss zum Zeitpunkt der Inbetriebnahme ein gültiges Zertifikat vorliegen. Weitere Informationen zu diesem Zertifikat finden Sie unter <a rel="noopener noreferrer" href="https://www.zerez.net/units-and-certificates"> ZEREZ</a>',
        },
    },
    inverterManualInputManufacturerTypeZerezId: {
        label: 'Einheit ist nicht in der Auswahl enthalten',
    },
    unitCertificateInvalidForInstalledPower: {
        text:
            'Die ausgewählte Erzeugungseinheit besitzt kein gültiges Einheitenzertifikat für ihre angegebene installierte Leistung P<sub>inst</sub>.',
    },
    inverterQuantity: {
        label: 'Anzahl',
    },
    inverterActivePowerAndApparentPower: {
        label: 'Wirk- und Scheinleistung',
        activePower: {
            placeholder: '120',
            unit: 'kW',
        },
        apparentPower: {
            placeholder: '125',
            unit: 'kVA',
        },
    },
    inverterTotalActivePower: {
        label: 'Summe Wirkleistung',
        unit: '{{ value }} kW',
    },
    inverterTotalApparentPower: {
        label: 'Summe Scheinleistung',
        unit: '{{ value }} kVA',
    },
    inverterAddRemoveModule: {
        addLabel: 'Wechselrichter hinzuf&uuml;gen',
        removeLabel: 'Wechselrichter entfernen',
    },
    inverterOverallActivePower: {
        label: 'Gesamtergebnis aus Summe Wirkleistung',
        unit: '{{ value }} kW',
    },
    inverterOverallActivePowerWarning: {
        text:
            'Die Wechselrichterleistung weicht wesentlich von der Modulleistung ab. Haben Sie die richtigen Leistungen gepflegt?',
    },
    inverterOverallApparentPower: {
        label: 'Gesamtergebnis aus Summe Scheinleistung',
        unit: '{{ value }} kVA',
    },
};
